import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import Toggle from '../Toggle.jsx';

const ToggleablePanel = ({
    enabled,
    setEnabled,
    children,
    onClick,
    hideToggle,
    hideCog,
    className
}) => {
    return (
        <div
            className={
                `flex group items-center justify-between rounded-lg bg-gray-200 p-6 ${className}`
            }
        >
            <div className="flex-1 cursor-pointer" onClick={onClick}>
                {children}
            </div>
            <div className="flex items-center">
                {!!onClick && !hideCog && (
                    <Cog6ToothIcon
                        className="w-5 h-5 cursor-pointer text-gray-500 group-hover:text-gray-600 mr-2"
                        onClick={onClick}
                    />
                )}
                {!hideToggle && (
                    <Toggle enabled={enabled} setEnabled={setEnabled} />
                )}
            </div>
        </div>
    );
};

export default ToggleablePanel;
